exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".sidebar-header{width:100%;min-height:3.438em;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;padding-bottom:.125em}", "", {"version":3,"sources":["/app/src/components/Elements/Sidebar/styles/SidebarHeader.css"],"names":[],"mappings":"AAAA,gBACE,WAAY,AACZ,mBAAoB,AACpB,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,8BAA+B,AACnC,sBAAuB,AACnB,mBAAoB,AACxB,qBAAwB,CACzB","file":"SidebarHeader.css","sourcesContent":[".sidebar-header {\n  width: 100%;\n  min-height: 3.438em;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  padding-bottom: 0.125em;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Elements/Sidebar/styles/SidebarHeader.css
// module id = 1474
// module chunks = 0